module.exports = __webpack_public_path__ + "img/19.93e978af.jpg";